import { post } from "./baseService";

// export async function getAppToken() {
//   let credentials = { email: "john1@example.com", password: "John@123!" };
//   const response = await post("login", credentials, false);
//   return response;
// }

export async function getAppToken() {
  let credentials = { email: "student@example.com", password: "123456" };
  const response = await post("login", credentials, false);
  return response;
}

export async function login(data) {
  const response = await post("login", data, false);
  return response;
}

export async function register(data) {
  const response = await post("users", data, true);
  return response;
}

export function updatePasswordUsingToken(data) {
  return post('update-password-using-token', data, true).then((response) => response)
}

export function loginWithGoogleAPI(data) {
  return post('google-login', data, false).then((response) => response)
}
export function loginWithFacebookAPI(data) {
  return post('facebook-login', data, false).then((response) => response)
}
export function sendCodeToUserToVerifyEmail(publicId) {
  return post('users/emailVerificationRequest', {publicId}, true).then((response) => response)
}
export function submitCodeToVerifyEmail(data) {
  return post('users/email-verification-code-process', data, true).then((response) => response)
}
export function getCurrentUser(publicId) {
  return post('users/get-current-user', {publicId}, true).then((response) => response)
}

export function getCurrentUserFavoriteUniversities(data) {
  return post('users/get-favorite-complete-details', data, true).then((response) => response)
}

export function getCurrentUserFavoriteOpportunities(data) {
  return post('users/get-favorite-complete-details', data, true).then((response) => response)
}
export function getCurrentUserFavoriteUniverisityOpportunitiesCount(data) {
  return post('users/count-favorite', data, true).then((response) => response)
}

export function getStudentOffers(data) {
  return post('users/student-redeem-offers', data, true).then(resp=>resp)
}